import { sanitizeUrl, sanitizeText } from './sanitize';

export function transformTextToLinks(message: string) {
    const urlRegex =
        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)(?<![\.,;:!?])/g;
    const messageTextToLink = message.replace(urlRegex, (url) => {
        const sanitizedUrl = sanitizeUrl(url);
        if (!sanitizedUrl) {
            return sanitizeText(url);
        }

        const escapedUrlText = sanitizeText(url);
        return `<a href="${sanitizedUrl}" style="color: inherit" target="_blank" rel="noopener noreferrer">${escapedUrlText}</a>`;
    });
    return messageTextToLink;
}
